const trimValue = (value) => (value || '').trim();
const splitConfigList = (value) => trimValue(value)
  .split(/[,\n]/)
  .map((item) => item.trim())
  .filter(Boolean);

export const AUTH_PROVIDER = trimValue(process.env.REACT_APP_AUTH_PROVIDER) || 'auth0';
const isEntraProvider = ['entra', 'entra-id', 'microsoft', 'msal'].includes(AUTH_PROVIDER.toLowerCase());
const DEFAULT_ENTRA_TENANT_ID = 'b556776d-8a0f-4dc9-bb5c-b5e28f8e36fe';
const DEFAULT_ENTRA_SPA_CLIENT_ID = 'd8d39f46-6a11-4973-ba4e-05cba247588f';
const DEFAULT_ENTRA_API_CLIENT_ID = '7c4ad720-6f64-4442-a896-e715224325bf';
const normalizeEntraAuthority = (value) => (
  trimValue(value)
    .replace(/\/oauth2\/v2\.0\/?$/i, '')
    .replace(/\/v2\.0\/?$/i, '')
);
const entraTenantId = trimValue(process.env.REACT_APP_ENTRA_TENANT_ID || process.env.REACT_APP_AUTH_ENTRA_TENANT_ID)
  || DEFAULT_ENTRA_TENANT_ID;
const entraClientId = trimValue(process.env.REACT_APP_ENTRA_CLIENT_ID || process.env.REACT_APP_AUTH_ENTRA_CLIENT_ID)
  || DEFAULT_ENTRA_SPA_CLIENT_ID;
const entraApiClientId = trimValue(process.env.REACT_APP_ENTRA_API_CLIENT_ID || process.env.REACT_APP_AUTH_ENTRA_API_CLIENT_ID)
  || DEFAULT_ENTRA_API_CLIENT_ID;
const entraAppIdUri = trimValue(process.env.REACT_APP_ENTRA_APP_ID_URI || process.env.REACT_APP_AUTH_ENTRA_APP_ID_URI)
  || `api://${entraApiClientId}`;
const entraScopeName = trimValue(process.env.REACT_APP_ENTRA_API_SCOPE || process.env.REACT_APP_AUTH_ENTRA_API_SCOPE)
  || 'access_as_user';
const entraApiScope = trimValue(process.env.REACT_APP_ENTRA_API_SCOPE_URI || process.env.REACT_APP_AUTH_API_SCOPE)
  || `${entraAppIdUri.replace(/\/+$/, '')}/${entraScopeName}`;
const entraAuthority = normalizeEntraAuthority(process.env.REACT_APP_ENTRA_AUTHORITY || process.env.REACT_APP_AUTH_ISSUER_BASE_URL)
  || `https://login.microsoftonline.com/${entraTenantId}`;
const entraPrompt = trimValue(process.env.REACT_APP_ENTRA_PROMPT || process.env.REACT_APP_AUTH_ENTRA_PROMPT)
  || '';
const entraDomainHint = trimValue(process.env.REACT_APP_ENTRA_DOMAIN_HINT || process.env.REACT_APP_AUTH_ENTRA_DOMAIN_HINT);

export const AUTH_CONFIG = {
  provider: AUTH_PROVIDER,
  isEntra: isEntraProvider,
  auth0: {
    domain: trimValue(process.env.REACT_APP_AUTH0_DOMAIN) || 'lbsaisolutions.uk.auth0.com',
    clientId: trimValue(process.env.REACT_APP_AUTH0_CLIENT_ID) || 'UWNvlWuOyMeu86qqCHQHlZMzIaKTTpt6'
  },
  entra: {
    tenantId: entraTenantId,
    clientId: entraClientId,
    apiClientId: entraApiClientId,
    appIdUri: entraAppIdUri,
    apiScope: entraApiScope,
    authority: entraAuthority,
    domainHint: entraDomainHint,
    prompt: entraPrompt
  },
  audience: trimValue(process.env.REACT_APP_AUTH_AUDIENCE) || (isEntraProvider ? entraAppIdUri : 'https://execed-ka-dev-api'),
  permissions: {
    user: trimValue(process.env.REACT_APP_AUTH_USER_PERMISSION) || 'execedka-user',
    admin: trimValue(process.env.REACT_APP_AUTH_ADMIN_PERMISSION) || 'execedka-admin'
  },
  roleAliases: {
    user: splitConfigList(process.env.REACT_APP_AUTH_USER_ROLE_NAMES || process.env.REACT_APP_AUTH_USER_ROLES),
    admin: splitConfigList(process.env.REACT_APP_AUTH_ADMIN_ROLE_NAMES || process.env.REACT_APP_AUTH_ADMIN_ROLES)
  },
  trustScopeClaims: trimValue(process.env.REACT_APP_AUTH_TRUST_SCOPE_CLAIMS).toLowerCase() === 'true'
};

// Route/access decisions trust permissions, Entra/Auth0 role claims, namespaced
// permission claims, and explicitly configured role aliases emitted in the access token.
export const AUTH_LOGIN_SCOPES_ARRAY = Array.from(new Set((isEntraProvider ? [
  'openid',
  'profile',
  'email',
  AUTH_CONFIG.entra.apiScope
] : [
  'openid',
  'profile',
  'email',
  AUTH_CONFIG.permissions.user,
  AUTH_CONFIG.permissions.admin
]).filter(Boolean)));

export const AUTH_TOKEN_SCOPES_ARRAY = Array.from(new Set((isEntraProvider ? [
  AUTH_CONFIG.entra.apiScope
] : AUTH_LOGIN_SCOPES_ARRAY).filter(Boolean)));

export const AUTH_SCOPES_ARRAY = Array.from(new Set((isEntraProvider ? [
  ...AUTH_LOGIN_SCOPES_ARRAY,
  ...AUTH_TOKEN_SCOPES_ARRAY
] : AUTH_LOGIN_SCOPES_ARRAY).filter(Boolean)));

export const AUTH_SCOPES = AUTH_SCOPES_ARRAY.join(' ');
